var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useMemo, useRef, useState, } from "react";
import cn from "classnames";
import debounce from "lodash.debounce";
import Icon from "components/icon";
import Portal from "components/portal";
import useToolTipTrigger from "helpers/hooks/useToolTipTrigger";
var FULL_WIDTH_THRESHOLD = 300;
var NARROW_WIDTH_THRESHOLD = 200;
function getRefOffet(ref) {
    var left = 0;
    var top = 0;
    var isNarrow = false;
    var position = "right";
    if (ref.current) {
        var _a = ref.current.getBoundingClientRect(), x = _a.x, y = _a.y, height = _a.height, width = _a.width;
        left = x + width / 2;
        top = y + height / 2;
    }
    var spaceOnRight = window.innerWidth - left;
    if (spaceOnRight < NARROW_WIDTH_THRESHOLD) {
        position = "left";
        isNarrow = left < FULL_WIDTH_THRESHOLD;
    }
    else {
        isNarrow = spaceOnRight < FULL_WIDTH_THRESHOLD;
    }
    return { style: { left: left, top: top }, isNarrow: isNarrow, position: position };
}
var Tooltip = function (_a) {
    var children = _a.children;
    var anchorRef = useRef(null);
    var _b = useToolTipTrigger(), isOpen = _b.isOpen, bind = _b.bind;
    var _c = useState(getRefOffet(anchorRef)), _d = _c[0], coordStyle = _d.style, position = _d.position, isNarrow = _d.isNarrow, setCoordPosition = _c[1];
    var updateCoordsDebounced = useMemo(function () {
        function updateCoords() {
            setCoordPosition(getRefOffet(anchorRef));
        }
        return debounce(updateCoords, 20);
    }, [anchorRef, setCoordPosition]);
    useEffect(function () {
        updateCoordsDebounced();
        if (isOpen) {
            window.addEventListener("scroll", updateCoordsDebounced);
            window.addEventListener("resize", updateCoordsDebounced);
            return function () {
                window.removeEventListener("scroll", updateCoordsDebounced);
                window.removeEventListener("resize", updateCoordsDebounced);
            };
        }
        return undefined;
    }, [isOpen, updateCoordsDebounced]);
    return (React.createElement("article", __assign({ "aria-describedby": "tooltip-content", className: "tooltip" }, bind),
        isOpen && (React.createElement(Portal, null,
            React.createElement("article", { id: "tooltip-content", role: "tooltip", className: cn("tooltip-portal", {
                    positionLeft: position === "left",
                    positionRight: position === "right",
                }), style: coordStyle },
                React.createElement("div", { className: "triangle" }),
                React.createElement("div", { className: cn("content", { isNarrow: isNarrow }) }, children)))),
        React.createElement("div", { className: "tooltip-icon-wrapper", ref: anchorRef },
            React.createElement(Icon, { type: "info" }))));
};
export default Tooltip;
